/* XENITH CORE 入荷優先案内ページ(Shopify Forms版)
   - ヒーローCTA→フォームへのスムーズスクロール(prefers-reduced-motionでは即時移動)
   - LPのSOLD OUTプレート等からの ?color=BLACK 遷移時、Formsの希望カラーselectを自動選択
     (Forms側のDOM構造に依存しない防御的実装。見つからなければ何もしない)
   - Shopify Forms自身の必須検証・送信・成功表示には介入しない
   - 個人情報のconsole出力・localStorage/sessionStorage/Cookie保存は行わない
   依存ライブラリなし・このページ専用 */
(function () {
  'use strict';
  if (window.__xcPriorityInit) return;
  window.__xcPriorityInit = true;

  /* ?color= の値(BLACK/SILVER/GOLD等)とFormsの選択肢(日英どちらの表記でも)を突き合わせる */
  var COLOR_ALIASES = {
    black: ['black', 'ブラック', '黒'],
    silver: ['silver', 'シルバー', '銀'],
    gold: ['gold', 'ゴールド', '金']
  };

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function colorKeyFor(value) {
    var v = normalize(value);
    if (!v) return null;
    for (var key in COLOR_ALIASES) {
      if (!Object.prototype.hasOwnProperty.call(COLOR_ALIASES, key)) continue;
      var aliases = COLOR_ALIASES[key];
      for (var i = 0; i < aliases.length; i += 1) {
        if (v === normalize(aliases[i])) return key;
      }
    }
    return null;
  }

  /* シェル内のselectを収集する。Shopify Formsはopenなshadow DOMに描画するため、
     shadowRootを持つ要素(shopify-forms-embed等)の内部も探す */
  function collectSelects(root, found) {
    found = found || [];
    var selects = root.querySelectorAll('select');
    for (var i = 0; i < selects.length; i += 1) found.push(selects[i]);
    var all = root.querySelectorAll('*');
    for (var j = 0; j < all.length; j += 1) {
      if (all[j].shadowRoot) collectSelects(all[j].shadowRoot, found);
    }
    return found;
  }

  /* シェル内のselectから「希望カラー」に該当する選択肢を探して選ぶ。成功でtrue */
  function preselectColor(shell, colorKey) {
    var selects = collectSelects(shell);
    for (var i = 0; i < selects.length; i += 1) {
      var select = selects[i];
      for (var j = 0; j < select.options.length; j += 1) {
        var opt = select.options[j];
        var optKey = colorKeyFor(opt.value) || colorKeyFor(opt.textContent);
        if (optKey === colorKey) {
          select.value = opt.value;
          try {
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
          } catch (e) { /* 古い環境ではイベント通知なしで値のみ設定 */ }
          return true;
        }
      }
    }
    return false;
  }

  function init() {
    var page = document.querySelector('[data-xc-priority]');
    if (!page || page.dataset.xcpBound) return;
    page.dataset.xcpBound = '1';

    var reduceMotion = false;
    try {
      reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) { /* matchMedia非対応環境は通常スクロール */ }

    /* ヒーローCTA→フォームへスクロール */
    var cta = page.querySelector('[data-xc-priority-cta]');
    var formFrame = document.getElementById('xc-priority-form');
    if (cta && formFrame) {
      cta.addEventListener('click', function (event) {
        event.preventDefault();
        formFrame.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        /* キーボード利用者のために最初の入力欄へフォーカスを送る */
        window.setTimeout(function () {
          var field = formFrame.querySelector('input, select, textarea, button, a');
          if (!field) return;
          try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); }
        }, reduceMotion ? 0 : 450);
      });
    }

    /* ?color= による希望カラー自動選択(Formsの描画完了を短時間だけ待つ) */
    var shell = page.querySelector('[data-xc-priority-form-shell]');
    var colorKey = null;
    try {
      colorKey = colorKeyFor(new URLSearchParams(window.location.search).get('color'));
    } catch (e) { /* URLSearchParams非対応環境では何もしない */ }
    if (shell && colorKey && !preselectColor(shell, colorKey)) {
      /* Formsの非同期描画(shadow DOM)を短時間だけポーリングで待つ */
      var tries = 0;
      var timer = window.setInterval(function () {
        tries += 1;
        if (preselectColor(shell, colorKey) || tries >= 15) window.clearInterval(timer);
      }, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    var page = document.querySelector('[data-xc-priority]');
    if (page) delete page.dataset.xcpBound;
    init();
  });
})();
